import { render, staticRenderFns } from "./RentalBookingDetails.vue?vue&type=template&id=5a833274&scoped=true&"
import script from "./RentalBookingDetails.vue?vue&type=script&lang=ts&"
export * from "./RentalBookingDetails.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5a833274",
  null
  
)

export default component.exports